/**
 * @author TEAM CMS
 *
 * Custom hook to track the state of the video player.
 */
// import { trackEvent } from '@svenskaspelab/nova-core/analytics';
import { useEffect, useRef } from 'react';
import { VideoControls } from '../../../core/utils/videoPlayerControls.js';
const {
  isPlaying
} = VideoControls;
export function useVideoStateTracker(video, interval = 2000) {
  if (typeof window === 'undefined') return;
  const {
    videoId,
    title,
    type
  } = video;
  if (type !== 'solidtango') return;
  const intervalRef = useRef(null);
  const hasTrackedRef = useRef(false);
  useEffect(() => {
    if (hasTrackedRef.current) {
      return function noop() {};
    }
    intervalRef.current = setInterval(() => {
      if (hasTrackedRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        return;
      }
      isPlaying(`video-${videoId}`, data => {
        const videoData = data;
        if (!videoData?.detail?.isPlaying) return;
        // Track event only once
        hasTrackedRef.current = true;
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
        const trackingEvent = {
          action: 'Video start - Solidtango',
          category: 'Solidtango video',
          optLabel: `${videoId} - ${title}`,
          optValue: 1
        };
        // Send tracking event
        // trackEvent(trackingEvent);
        // Stop polling immediately
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      });
    }, interval);
    return function cleanup() {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      hasTrackedRef.current = false;
    };
  }, [video, interval]);
}